"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _Functions = require("../core/Functions");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _deprecated = _interopRequireDefault(require("../utils/propTypes/deprecated"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _decorators = require("../utils/propTypes/decorators");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var getOnOverlayClickWarning = function getOnOverlayClickWarning() {
  return {
    message: 'UIOverlay: The `onOverlayClick` prop is deprecated. ' + 'Please do not trigger actions from an overlay click.',
    key: 'onOverlayClick',
    url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6046'
  };
};

var getStyle = function getStyle(style, centerContent, width) {
  return centerContent ? (0, _extends2.default)({}, style, {
    maxWidth: width
  }) : style;
};

var USE_CLASSES = {
  dark: '',
  light: 'private-overlay--light'
};

var UIOverlay =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIOverlay, _React$Component);

  function UIOverlay(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIOverlay);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIOverlay).call(this, props));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onOverlayClick = _this$props.onOverlayClick;
      var target = evt.target;
      (0, _Functions.callIfPossible)(onClick, evt);

      if (target === _this._outerEl || target === _this._innerEl) {
        (0, _Functions.callIfPossible)(onOverlayClick, evt);
      }
    };

    _this.outerRefCallback = function (ref) {
      _this._outerEl = (0, _reactDom.findDOMNode)(ref);
    };

    _this.innerRefCallback = function (ref) {
      _this._innerEl = ref;
    };

    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    return _this;
  }

  (0, _createClass2.default)(UIOverlay, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          centerContent = _this$props2.centerContent,
          children = _this$props2.children,
          className = _this$props2.className,
          contextual = _this$props2.contextual,
          onClick = _this$props2.onClick,
          onOverlayClick = _this$props2.onOverlayClick,
          style = _this$props2.style,
          tabIndex = _this$props2.tabIndex,
          use = _this$props2.use,
          width = _this$props2.width,
          Inner = _this$props2.Inner,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["centerContent", "children", "className", "contextual", "onClick", "onOverlayClick", "style", "tabIndex", "use", "width", "Inner"]);
      var isSandboxed = contextual || this.context.sandboxed;
      var computedClassName = (0, _classnames.default)(className, 'private-overlay', 'uiOverlay-backdrop', USE_CLASSES[use], {
        'private-overlay--contextual': isSandboxed
      });
      var computedChildrenWrapperClassName = (0, _classnames.default)({
        'private-modal__container': centerContent
      });
      var isClickable = onClick || onOverlayClick;
      var Overlay = isClickable ? _UIClickable.default : 'div';
      var overlayProps = isClickable ? {
        cursor: 'auto'
      } : undefined;
      return _react.default.createElement(Overlay, (0, _extends2.default)({}, rest, overlayProps, {
        className: computedClassName,
        onClick: this.handleClick,
        ref: this.outerRefCallback,
        role: "presentation",
        tabIndex: isSandboxed ? null : tabIndex
      }), _react.default.createElement(Inner, {
        className: computedChildrenWrapperClassName,
        ref: this.innerRefCallback,
        style: this._getStyle(style, centerContent, width)
      }, children));
    }
  }]);
  return UIOverlay;
}(_react.default.Component);

UIOverlay.propTypes = {
  centerContent: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node,
  contextual: _propTypes.default.bool.isRequired,
  onOverlayClick: (0, _deprecated.default)(_propTypes.default.func, getOnOverlayClickWarning),
  use: _propTypes.default.oneOf(Object.keys(USE_CLASSES)),
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  Inner: (0, _decorators.hidden)(_component.default)
};
UIOverlay.contextTypes = {
  sandboxed: _propTypes.default.bool
};
UIOverlay.defaultProps = {
  centerContent: true,
  contextual: false,
  use: 'dark',
  Inner: 'div'
};
UIOverlay.displayName = 'UIOverlay';
var _default = UIOverlay;
exports.default = _default;
module.exports = exports.default;